module.exports = __webpack_public_path__ + "img/TJ - Small - White.99bd1bda.png";